import { createAction } from '@reduxjs/toolkit';
import {
  ApiPaginationResponse,
  TableQueryParameters,
} from 'src/components/ui/Table/Table.interface';

import { Error } from '../models/Errors';
import { Product } from '../models/Product';

export const PRODUCT_SLICE = 'product';

/* Product list */
export const getProductList = createAction<{
  params: TableQueryParameters;
  mId?: string;
}>(`${PRODUCT_SLICE}/getProductList`);

export const setProductList = createAction<ApiPaginationResponse<Product[]>>(
  `${PRODUCT_SLICE}/setProductList`
);

/* Add product */
export const addProduct = createAction<Product>(`${PRODUCT_SLICE}/addProduct`);

/* Get product */
export const getProduct = createAction<{ productId: string }>(
  `${PRODUCT_SLICE}/getProduct`
);

/* Set product */
export const setProduct = createAction<Product>(`${PRODUCT_SLICE}/setProduct`);

/* Edit product */
export const editProduct = createAction<Product>(
  `${PRODUCT_SLICE}/editProduct`
);

/* Remove product */
export const removeProduct = createAction<{ productId: string }>(
  `${PRODUCT_SLICE}/removeProduct`
);

/* Get errors table */
export const getErrorsTable = createAction<{ params: TableQueryParameters }>(
  `${PRODUCT_SLICE}/getErrors`
);

/* Set errors table */
export const setErrorsTable = createAction<Error[]>(
  `${PRODUCT_SLICE}/setErrors`
);
